import React from 'react';
import PropTypes from "prop-types";
import { Oval } from 'react-loader-spinner';



const SpinnerPage = props => {

    const { loading, noPadding } = props;

        if (loading) {
    
          return (
            
            <div className="u-flex-center u-flex-justify-center" style={noPadding ? {width: '100%'} : {padding: '20rem 10rem', width: '100%'}}>

                {/* <Loader
                type="Oval"
                color="#555555"
                height={50}
                width={50}
            /> */}
                  <Oval
                    color={"#2F68F4"}
                    secondaryColor="#2F68F4"
                    height={50}
                    width={50}
                />


            </div>    
            
          );
          
      } 

      return props.children; 
      
    
}




SpinnerPage.propTypes = {
    loading: PropTypes.bool,
};

const page = SpinnerPage;
export  { page as SpinnerPage };


  

  
